<template>
  <v-container fluid class="px-0">
    <div class="bill-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.billtype }} {{ initvalue.billnum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" align="right">
                    <v-btn
                      class="button-shadow mr-1"
                        @click="Done"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Bill Num</td>
                        <td>{{ initvalue.billnum }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Bill Date</td>
                        <td>{{ new Date(initvalue.billdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Due Date</td>
                        <td>{{ new Date(initvalue.billduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Status</td>
                        <td>{{ initvalue.billstatus }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="5">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Name</td>
                        <td>{{ initvalue.billname }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Address</td>
                        <td>{{ initvalue.billaddress }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Phone</td>
                        <td>{{ initvalue.billphone }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Mobile</td>
                        <td>{{ initvalue.billphone }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="3">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Total</td>
                        <td>{{ data_total.toFixed(2) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Payments</td>
                        <td>{{ data_payments.toFixed(2) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Balance</td>
                        <td>{{ (data_total - data_payments).toFixed(2) }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Items
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-payments'"
                    >
                      Payments
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :loading="isReceiving"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="header_items"
                            :items="transactions"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemimage="{ item }">
                              <v-img
                              v-if="item.itemimage" 
                              v-bind:src="item.itemimage"
                              max-height="100"
                              max-width="100"
                            ></v-img>
                            </template>
                            <template v-slot:item.accountid="{ item }">
                              <p v-if="item.accountid!=null" class="two-line">
                                {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountnum'] : '' }}
                                :
                                {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                              </p>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              <p v-if="item.transdate!=null" class="two-line">{{ new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                            </template>
                            <template v-slot:item.itemamount="{ item }">
                              <p v-if="item.itemamount!=null" class="two-line">{{ item.itemamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-payments'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="header_payments"
                            :items="payments"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.transdesc="{ item }">
                              <p v-if="item.transdesc!=null" class="two-line"><strong>{{ item.transdesc }}:</strong></p>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              <p v-if="item.transdate!=null" class="two-line">{{ new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                            </template>
                            <template v-slot:item.transamount="{ item }">
                              <p v-if="item.transamount!=null" class="two-line">{{ item.transamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item :value="'tab-files'" :key="3">
                      <FileView :id="initvalue._id" :route="`bill`" :files="files" :data="initvalue"/>
                    </v-tab-item>                    
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FileView from "@/pages/File/Components/FileView.vue";

export default {
  name: "BillView",
  components: {
    FileView
  },
  data() {
    return {
      initvalue: {},
      transactions: [],
      payments: [],
      files: [],
      images: [],
      selectedTab: "1",
      showImageDialog: false,
      image: null,
      header_items: [
        { text: 'Date', value: 'transdate' },  
        { text: 'Account', value: 'accountid' },
        { text: 'Description', value: 'itemdesc', width: '30%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
      ],
      header_payments: [
        { text: 'Payment Date', value: 'transdate', width: '12%' },  
        { text: 'Reference Num', value: 'refnum' },  
        { text: '', value: 'transdesc', width: '8%', align: 'right'},
        { text: 'Payment Amount', value: 'transamount', width: '12%', align: 'right'},
      ],
      header_files: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      itemPerPage: 500,
      footer: {'items-per-page-options': [500, 1000, 5000]},
      selected: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Bill', ['isReceiving']),
    data_total(){
      let result = this.transactions.reduce(function (last, json) {return last + json.itemamount;}, 0);
      return result;
    },
    data_payments(){
      let result = this.payments.reduce(function (last, json) {return last + json.transamount;}, 0);
      return result;
    },
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Bill', ["getBillRequest"]),
    clickImage(image){
      this.image = image;
      this.showImageDialog = true;
    },
    Done(){
      this.$router.push({ name: 'BillList' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "BillList" });

    let result = await this.getBillRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    this.payments = Object.assign([], result.payments);
    this.files = Object.assign([], result.files);
    this.images = Object.assign([], result.images);

    if(this.accounts.length==0) await this.getAccountsRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
